// Below the breakpoint a row table becomes cards: rows are blocks, each cell shows its
// data-label above the value. Same DOM either way, so table/row/cell roles stay intact.
export type StackAt = 'md' | 'lg';

export interface StackClasses {
  table: string;
  head: string;
  body: string;
  row: string;
  cell: string;
  label: string;
}

// Literal strings only, so Tailwind's scanner emits every variant.
const CLASSES: Record<StackAt, StackClasses> = {
  md: {
    table: 'w-full table-fixed text-sm max-md:block',
    head: 'max-md:hidden',
    body: 'max-md:block',
    row: 'max-md:block max-md:mx-3 max-md:my-2 max-md:rounded-md max-md:py-1',
    cell: 'max-md:block max-md:w-full max-md:px-3 max-md:py-1 max-md:text-left',
    label:
      'max-md:before:block max-md:before:text-xs max-md:before:font-medium max-md:before:text-content-muted max-md:before:content-[attr(data-label)]'
  },
  lg: {
    table: 'w-full table-fixed text-sm max-lg:block',
    head: 'max-lg:hidden',
    body: 'max-lg:block',
    row: 'max-lg:block max-lg:mx-3 max-lg:my-2 max-lg:rounded-md max-lg:py-1',
    cell: 'max-lg:block max-lg:w-full max-lg:px-3 max-lg:py-1 max-lg:text-left',
    label:
      'max-lg:before:block max-lg:before:text-xs max-lg:before:font-medium max-lg:before:text-content-muted max-lg:before:content-[attr(data-label)]'
  }
};

export const stackClasses = (at: StackAt = 'md'): StackClasses => CLASSES[at];

export const joinClasses = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');
